export default __webpack_public_path__ + "static/media/leader_notes_detailed.5a6c9ed3.pdf";